import { getFieldSetting } from "@app.raytd.com/common/utils/test-suites/getFieldSetting";
import { TestSuite } from "@app.raytd.com/common/types/test-suite";
import { TestSuiteType } from "@app.raytd.com/common/types/test-suite-types";

export function isCustomField(fieldName: string) {
    return fieldName.startsWith('custom.');
}

/**
 * Returns the id of the custom field without the 'custom.' prefix
 * @param fieldName 
 * @returns 
 */
export function getCustomFieldId(fieldName: string) {
    return fieldName.replace('custom.', '');
}

function isTestFieldRequired(testSuite: Pick<TestSuite, 'type' | 'settings' | 'custom_fields'> | null, fieldName: string) {
    if (['assessmentId', 'assetId', 'test_specification_id'].includes(fieldName)) return true;
    if (!testSuite) return false;

    if (isCustomField(fieldName)) {
        const customFieldId = getCustomFieldId(fieldName);
        const field = testSuite.custom_fields?.find((s: any) => s.field_id === customFieldId);

        return field ? field.required ?? false : false;
    } else {
        const fieldSettings = getFieldSetting(
            fieldName,
            testSuite.type as TestSuiteType,
            testSuite.settings || []
        );

        return fieldSettings.required;
    }
}

export default isTestFieldRequired;